/**
 * Status Permintaan Pembelian (kontrak hal.9). Backend mengirim `status_id`
 * mentah tanpa label; label + warna dimiliki FE. Transisi Terbuka → Sebagian
 * Dipesan → Ditutup dihitung backend dari sisa qty yang ditarik ke PO — FE
 * TIDAK menghitung/menebak transisi, cukup menampilkan status_id yang datang.
 */
const statusConst = {
  // Status global modul approval (sama dgn invoice/permintaan barang)
  WAITING_APPROVAL: 111,
  REJECTED: 112,
  OPEN: 5,
  PARTIAL_ORDERED: 45,
  CLOSED: 7,
}

const statusColors = [
  { id: statusConst.WAITING_APPROVAL, labelId: 'approvals.waiting_for_approval', color: '#FAAD14' },
  { id: statusConst.REJECTED, labelId: 'approvals.rejected', color: '#CF2A28' },
  { id: statusConst.OPEN, labelId: 'purchaseRequest.status_open', color: '#13A4FF' },
  { id: statusConst.PARTIAL_ORDERED, labelId: 'purchaseRequest.status_partial_ordered', color: '#13A4FF' },
  { id: statusConst.CLOSED, labelId: 'purchaseRequest.status_closed', color: '#11A428' },
]

/**
 * Afordansi UI per status yang BISA diturunkan dari `status_id` saja: Buat PO,
 * Tutup. Ubah/Hapus/Setujui/Tolak/Ajukan ulang sengaja TIDAK di
 * sini — syaratnya dijawab flag backend (is_editable, is_deletable,
 * is_approveable, is_revertable) di response detail & daftar, seperti MR.
 */
const statusTransitions = {
  [statusConst.WAITING_APPROVAL]: {},
  [statusConst.REJECTED]: {},
  // "Tutup" hanya boleh muncul saat status 5 — PATCH /status; status 45 tidak
  // bisa diubah manual (kontrak hal.9). Buat PO tetap tersedia di 5 & 45 (lihat
  // orderableStatusIds).
  [statusConst.OPEN]: { createPurchaseOrder: true, close: true },
  [statusConst.PARTIAL_ORDERED]: { createPurchaseOrder: true },
  [statusConst.CLOSED]: {},
}

/** Status yang boleh ditarik ke Pesanan Pembelian — memfilter daftar PR di dialog PO. */
const orderableStatusIds = [statusConst.OPEN, statusConst.PARTIAL_ORDERED]

export { statusConst, statusColors, statusTransitions, orderableStatusIds }
